export default __webpack_public_path__ + "static/media/Ies_LogoMonterrey.e7e69806.png";